
import React from 'react';
import Box from '@mui/material/Box';
import VisibilityIcon from '@mui/icons-material/VisibilityOutlined';
import { IconButton, Tooltip } from '@mui/material';
import { MuiTable, Progress, TableTopSearch, SingleViewDialog } from 'components';
import DepartmentServices from 'services/DepartmentServices';


const departmentColumns = [
  {
    accessorKey: "name",
    header: "Name",
    Cell: ({ row }) => <span>{row.original.name || ""}</span>,
  },
  {
    accessorKey: "code",
    header: "Department Code",
    Cell: ({ row }) => <span>{row.original.code || ""}</span>,
  },
  {
    accessorKey: 'action',
    header: 'Action',
    Cell: ({ row, handleView }) => (
      <Tooltip title="View details">
        <IconButton size="small" color="primary" onClick={() => handleView(row.original)}>
          <VisibilityIcon />
        </IconButton>
      </Tooltip>
    ),
  },
];

const DepartmentsTab = ({ org }) => {

  const [departmentData, setDepartmentData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [filters, setFilters] = React.useState({
    page: 0,
    limit: 10,
    search: ""
  });
  const [totalItems, setTotalItems] = React.useState(0);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [singleData, setSingleData] = React.useState(null);

  const handleView = (row) => {
    setSingleData(row);
    setOpenDialog(true);
  };

  const setPage = (page) => {
    setFilters(prev => ({ 
      ...prev, 
      page:page-1
     }));
  };

  const setPageSize = (size) => {
    setFilters(prev => ({
      ...prev, 
      page: 0, 
      limit: size
    }));
  };

  React.useEffect(() => {
    if (!org?.id) {
      return;
    }
    setLoading(true);
    const fetchDepartments = async () => {
      try {
        const params = {
          organization_id: org.id,
          search: filters.search,
          page: filters.page,
          limit: filters.limit,
          status: 'Active'
        };
        const response = await DepartmentServices.get(params);
        const total = response?.data?.view?.totalItems || response?.data?.totalItems || 0;
        setTotalItems(total);
        const departments = response?.data?.view?.data || response?.data?.data || [];
        setDepartmentData(Array.isArray(departments) ? departments : []);
      } catch (err) {
        setDepartmentData([]);
        setTotalItems(0);
      } finally {
        setLoading(false);
      }
    };
    fetchDepartments();
  }, [org?.id, filters.page, filters.limit, filters.search]);

  return (
    <>

        <TableTopSearch
          title='Departments'
          showSearch={true}
          showTotalWithTitle={true}
          rowCount={totalItems}
          onSubmitSearch={null}
          onSearchChange={(e) => {
            setFilters(prevData => ({
              ...prevData,
              search: e.target.value
            }));
          }}
        />
      {loading ? (
        <Box >
          <Progress />
        </Box>
      ) : (
        <>
          <MuiTable
            columns={departmentColumns.map(col => {
              if (col.accessorKey === 'action') {
                return {
                  ...col,
                  Cell: ({ row }) => col.Cell({ row, handleView })
                };
              }
              return col;
            })}
            data={departmentData}
            manualPagination={true}
            rowCount={totalItems}
            currentPage={filters.page}
            pageSize={filters.limit}
            onPageChange={setPage}
            onPageSizeChange={setPageSize}
            loading={loading}
          />
          <SingleViewDialog
            open={openDialog}
            onClose={() => setOpenDialog(false)}
            data={{
              title: singleData?.name,
              otherData: [
                {
                  label: "Status",
                  value: singleData?.status
                },
                {
                  label: "Department Code",
                  value: singleData?.code
                },
                {
                  label: "Description",
                  value: singleData?.description
                },
                {
                  label: "Created At",
                  value: singleData?.createdAt ? new Date(singleData.createdAt).toLocaleString() : ""
                },
                {
                  label: "Updated At",
                  value: singleData?.updatedAt ? new Date(singleData.updatedAt).toLocaleString() : ""
                }
              ]
            }}
          />
        </>
      )}
    </>
  );
};

export default DepartmentsTab;
